// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MaH-","type":"styles_type__mVhIZ","choices":"styles_choices__25qHr"};